import { h, defineComponent } from 'vue'
import { t } from 'utils/i18n.js'

// A message with links or bold words in the middle, as ONE sentence:
//
//   app.x.help: "Read the %{guide} or %{contact}."
//
//   <i18n-t keypath="app.x.help" tag="p" class="text-sm">
//     <template #guide><a href="/guide">{{ $t('app.x.guide') }}</a></template>
//     <template #contact><a href="/contact">{{ $t('app.x.contact') }}</a></template>
//   </i18n-t>
//
// Translating the pieces around a link separately cannot work: languages put the words in a different
// order, so each slot is a %{name} inside the message and the translator moves it where the grammar
// wants it. Plain values go in `values`, like t().
export default defineComponent({
  name: 'I18nT',
  inheritAttrs: false,
  props: {
    keypath: { type: String, required: true },
    tag: { type: String, default: 'span' },
    values: { type: Object, default: () => ({}) },
  },
  setup(props, { slots, attrs }) {
    return () => {
      const message = t(props.keypath, props.values)
      const children = message
        .split(/(%\{\w+\})/)
        .filter((part) => part !== '')
        .map((part) => {
          const slot = part.match(/^%\{(\w+)\}$/)
          const render = slot && slots[slot[1]]
          return render ? render() : part
        })
        .flat()
      return h(props.tag, attrs, children)
    }
  },
})
